import { ssoClient } from "./client";

const Login = (username, password, appId, selectedrole) => {
  return ssoClient.post('/User/Login', {
    'username': username,
    'password': password,
    'appId': appId,
    'selectedRole': selectedrole
  });
}
const CheckAuth = (hashCode, sharedKey, roleName) => {
  return ssoClient
    .get("User/CheckAuth"
      , {
        params: {
          'hash': hashCode,
          'sharedKey': sharedKey,
          'roleName': roleName
        }
      }
    );
}
const ChangePassword = (oldPass, newPass, newPassReply) => {
  return ssoClient.post('User/ChangePassword', {

    oldPassword: oldPass,
    password: newPass,
    rePassword: newPassReply

  });
}
const GetPermissions = (appid) => {
  return ssoClient
    .get("Role/GetPermissions"
      , {
        params: {
          'appId': appid
        }
      }
    );

}
const GetMenuItems = (appid) => {
  return ssoClient
    .get("Menu/GetItems", {
      params: {
        'appId': appid
      }
    });

}

const UserApi = { Login, CheckAuth, ChangePassword, GetMenuItems, GetPermissions }
export default UserApi;
